import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { Link } from 'react-router-dom';
import colegioIcon from '../assets/images/colegio-icon.png';
import '../assets/styles/AdmissionModal.css';

const ADMISSION_URL = 'https://admision.mineduc.cl/registro/';

function AdmissionModal() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const timer = window.setTimeout(() => setIsOpen(true), 500);

    return () => window.clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!isOpen) return undefined;

    const closeOnEscape = (event) => {
      if (event.key === 'Escape') setIsOpen(false);
    };

    document.addEventListener('keydown', closeOnEscape);
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', closeOnEscape);
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return createPortal(
    <div
      className="admission-modal-overlay"
      role="presentation"
      onClick={() => setIsOpen(false)}
    >
      <section
        className="admission-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="admission-modal-title"
        onClick={(event) => event.stopPropagation()}
      >
        <button
          type="button"
          className="admission-modal-close"
          aria-label="Cerrar anuncio de matrículas"
          onClick={() => setIsOpen(false)}
        >
          ×
        </button>

        <div className="admission-modal-brand">
          <img src={colegioIcon} alt="Logo Colegio Cristiano Le Beau Jour" />
        </div>
        <p className="admission-modal-eyebrow">Colegio Cristiano Le Beau Jour</p>
        <h2 id="admission-modal-title">¡Matrículas Abiertas!</h2>
        <p className="admission-modal-subtitle">
          Postula ahora y sé parte de nuestra comunidad educativa.
        </p>

        <div className="admission-modal-steps">
          <p><strong>1.</strong> Regístrate como apoderado en el portal de MINEDUC.</p>
          <p><strong>2.</strong> Busca el establecimiento <strong>“Le Beau Jour”</strong>.</p>
          <p><strong>3.</strong> Completa tu postulación siguiendo las instrucciones.</p>
        </div>

        <a
          className="admission-modal-cta"
          href={ADMISSION_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          ¡Matricúlate Aquí!
        </a>
        <Link
          to="/admision"
          className="admission-modal-info"
          onClick={() => setIsOpen(false)}
        >
          Más información sobre admisión
        </Link>
        <button
          type="button"
          className="admission-modal-later"
          onClick={() => setIsOpen(false)}
        >
          Quizás más tarde
        </button>
      </section>
    </div>,
    document.body
  );
}

export default AdmissionModal;
